import { render, staticRenderFns } from "./InfoColorRectIcon.vue?vue&type=template&id=51b2238a&"
import script from "./InfoColorRectIcon.vue?vue&type=script&lang=js&"
export * from "./InfoColorRectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports